<template>
  <div class="app-container content-information">
    <div class="navigation demo-detail">
      <el-button size="mini" type="primary-icon-medium" icon="icon-ccui-return" @click="handleBack">返回</el-button>
      <div class="cut-line"/>
      <!-- 面包屑 -->
      <el-breadcrumb class="crumbs-container" separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">模板应用</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/tmpl/demo/demo-list' }">功能模块</el-breadcrumb-item>
        <el-breadcrumb-item>查看 <span>{{ name }}</span></el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="center-information">
      <el-detail-info
        :title-message="titleMessage"
        :info-title="infoTitle"
        :info-content="infoContent"
        :type="detailType"
      />
    </div>
    <div class="bottom-guide detail-bottom">
      <ul class="bottom-button">
        <li>
          <el-button type="bottom" icon="icon-ccui-return" @click="handleBack">返回</el-button>
        </li>
        <li class="bottom-center-solid"></li>
        <li>
          <el-button type="bottom" icon="icon-ccui-cancel" @click="deleteHandle">删除</el-button>
        </li>
        <li class="bottom-center-solid"></li>
        <li>
          <el-button type="bottom" icon="icon-ccui-copy" @click="handleCopy">复制</el-button>
        </li>
        <li>
          <el-button type="bottom" icon="icon-ccui-print">打印</el-button>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { getList } from '@/api/demo-detail'
import { delList } from '@/api/demo-list'

export default {
  name: 'NewContract',
  data () {
    return {
      name: '',
      detailType: 'detail-default',
      titleMessage: {
        title: '基本信息'
      },
      infoContent: {
        title: '',
        clause: []
      },
      formData: null,
      infoTitle: []
    }
  },
  activated () {
    const id = this.$route.params.demoId
    this.name = this.$route.params.demoName
    this.getList(id)
  },
  methods: {
    handleCopy () {
      console.log('提交复制信息')
      this.$router.push('/tmpl/demo/demo-copy/' + this.form.demoId)
    },
    // 删除查看页并跳转到list页
    deleteHandle () {
      this.delList()
    },
    getList (id) {
      const obj = {
        demoId: id,
        isShowLoading: true
      }
      getList(obj).then(res => {
        console.log('输出的res', res)
        this.form = res.data.data
        this.formData = res.data.data
        this.infoTitle = [
          {
            label: '序号',
            titleContent: this.formData.demoId
          }, {
            label: '名称',
            titleContent: this.formData.demoName
          }, {
            label: '用户名',
            titleContent: this.formData.userName
          }, {
            label: '年龄',
            titleContent: this.formData.age
          }, {
            label: '手机号',
            titleContent: this.formData.phone
          }, {
            label: '单价',
            titleContent: this.formData.skuPrince
          }, {
            label: '库存量',
            titleContent: this.formData.skuNum
          }, {
            label: '修改时间',
            titleContent: this.formData.createDate
          }, {
            label: '修改人ID',
            titleContent: this.formData.modifyUserId
          }, {
            label: '修改人',
            titleContent: this.formData.modifyUser
          }, {
            label: '是否启用',
            titleContent: this.formData.status
          }
        ]
        console.log('detail', res.data.data)
      }).catch(e => {
        console.log(e)
      })
    },
    delList () {
      delList({
        demoIds: [this.form.demoId],
        isShowLoading: true
      }).then(res => {
        console.log('接收的表格参数', res)
        this.$message({
          message: '删除成功',
          type: 'success',
          // duration: 3000,
          showClose: true,
          offset: document.body.clientHeight / 2 - 21
        })
        this.$router.push({ path: '/tmpl/demo/demo-list' })
      }).catch(e => {
        console.log(e)
      })
    },
    handleBack () {
      this.$router.push({ path: '/tmpl/demo/demo-list' })
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "~@/styles/variables";
</style>
